import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Users
export const createOrGetUser = (name) => api.post("/users", { name }).then((r) => r.data);
export const getUser = (id) => api.get(`/users/${id}`).then((r) => r.data);

// Content
export const getContent = () => api.get("/content").then((r) => r.data);

// Progress
export const markProgress = (user_id, module_id, subtopic_id) =>
  api.post("/progress", { user_id, module_id, subtopic_id }).then((r) => r.data);
export const getProgress = (user_id) =>
  api.get(`/progress/${user_id}`).then((r) => r.data);

// Quiz
export const submitQuiz = (user_id, module_id, quiz_id, selected_index) =>
  api.post("/quiz", { user_id, module_id, quiz_id, selected_index }).then((r) => r.data);

// Bookmarks
export const toggleBookmark = (user_id, module_id, subtopic_id, subtopic_title) =>
  api.post("/bookmarks/toggle", { user_id, module_id, subtopic_id, subtopic_title }).then((r) => r.data);
export const listBookmarks = (user_id) =>
  api.get(`/bookmarks/${user_id}`).then((r) => r.data);

// Certificate
export const certificateStatus = (user_id) =>
  api.get(`/certificate/${user_id}`).then((r) => r.data);
export const recordShare = (user_id, platform = "linkedin") =>
  api.post(`/certificate/share`, { user_id, platform }).then((r) => r.data);

// Diagrams
export const generateDiagram = (module_id) =>
  api.post("/diagrams/generate", { module_id }).then((r) => r.data);
export const getDiagram = (module_id) =>
  api.get(`/diagrams/${module_id}`).then((r) => r.data);
